const RESOURCE_NAME = "entities/productTariffs";

export default {};
